<template>
  <div class="indicator_list">
    <FilterGraphIndicatorsListItem
      v-for="item in list"
      :key="item.id"
      :item="item"
      @change-graph="changeGraph"
    />
  </div>
</template>
<script>
export default {
  name: 'FilterGraphIndicatorsList',
  components: {
    FilterGraphIndicatorsListItem: () => import('@/components/graph/FilterGraphIndicatorsListItem.vue'),
  },
  
  props: {
    list: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      form: {
        graphs: []
      }
    }
  },

  computed: {
    
  },

  methods: {
    changeGraph (id) {
      if (this.form.graphs.includes(id)) {
        this.form.graphs = this.form.graphs.filter(item => item != id)
      } else {
        this.form.graphs.push(id)
      }
      
      this.$store.dispatch('graphIds',this.form.graphs.toString())
    }
  }
}
</script>
<style lang="scss" scoped>

</style>